module.exports = __webpack_public_path__ + "img/404-image.4a2dbed5.png";